(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["1849-scent-compass"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mercantile-scent-compass')) {
    customElements.define('mercantile-scent-compass', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.choices = Array.from(this.querySelectorAll('[data-compass-choice]'));
        this.panels = Array.from(this.querySelectorAll('[data-compass-panel]'));
        const controls = this.querySelector('[data-compass-controls]');
        if (!controls || !this.choices.length || !this.panels.length) return;
        this.addEventListener('click', (event) => {
          const choice = event.target.closest('[data-compass-choice]');
          if (choice && this.contains(choice)) this.selectMood(choice.dataset.compassChoice, true);
        }, { signal: this.controller.signal });
        this.addEventListener('shopify:block:select', (event) => {
          const panel = event.target.closest('[data-compass-panel]');
          if (panel && this.contains(panel)) this.selectMood(panel.dataset.compassPanel, false);
        }, { signal: this.controller.signal });
        this.selectMood(this.choices[0].dataset.compassChoice, false);
        controls.hidden = false;
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
      selectMood(id, announce) {
        const selected = this.choices.find((choice) => choice.dataset.compassChoice === id);
        if (!selected || !this.panels.some((panel) => panel.dataset.compassPanel === id)) return;
        this.choices.forEach((choice) => choice.setAttribute('aria-pressed', String(choice === selected)));
        this.panels.forEach((panel) => { panel.hidden = panel.dataset.compassPanel !== id; });
        if (announce) {
          const status = this.querySelector('p[data-compass-status]');
          if (status) status.textContent = selected.dataset.compassStatus.replace('__MOOD__', selected.textContent.trim());
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('click', (event) => {
  const link = event.target.closest('a[href]');
  if (!link) return;
  const url = new URL(link.href, window.location.href);
  if (url.origin !== window.location.origin || url.pathname !== window.location.pathname || !url.hash) return;
  const target = document.getElementById(decodeURIComponent(url.hash.slice(1)));
  if (!target) return;
  if (target.tagName === 'DETAILS') target.open = true;
  const sidebar = link.closest('header-sidebar');
  if (sidebar) sidebar.shadowRoot?.querySelector('dialog-close-button button')?.click();
});

  } catch(e) { console.error(e); }
})();
})();
